<template>
  <spr-dialog name="company" :show="show" title="分部" @confirm="handleConfirm" @open="handleOpen" @update:show="(flag) => this.$emit('update:show', flag)">
    <el-form ref="form" :inline="true" :model="Form" label-suffix="：" label-width="110px" style="margin: 0 20px;" :rules="Rules">
        <el-form-item label="分部名称" prop="Name">
          <el-input v-model="Form.Name" style="width: 280px; margin-right: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="分部地址" prop="Address">
          <spr-address
            :province-id.sync="Form.ProvinceId"
            :city-id.sync="Form.CityId"
            :county-id.sync="Form.CountyId"
            :address.sync="Form.Address"></spr-address>
        </el-form-item>
        <el-form-item label="联系方式" prop="MobilePhone">
          <el-input style="width: 350px" v-model="Form.MobilePhone"></el-input>
        </el-form-item>
      </el-form>
  </spr-dialog>
</template>

<script>
import SprDialog from './Dialog'
import SprAddress from '@/components/common/Address'
import _ from 'lodash'

export default {
  data() {
    return {
      Form: {},
      Rules: {
        Name: [{required: true, message: '该字段必填', trigger: 'blur'}],
        Address: [{required: true, message: '该字段必填', trigger: 'blur'}],
        MobilePhone: [
          {required: true, message: '该字段必填', trigger: 'blur'},
          {pattern: /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/, message: '手机号格式错误'},
        ],
      },
    }
  },
  props: {
    form: Object,
    show: Boolean,
  },
  methods: {
    handleOpen() {
      this.$set(this, 'Form', Object.assign({
        Name: null,
        ProvinceId: null,
        CityId: null,
        CountyId: null,
        Address: null,
        MobilePhone: null,
      }, this.form))
    },
    handleConfirm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit('confirm', _.pick(this.Form, [
            'Id',
            'Name',
            'ProvinceId',
            'CityId',
            'CountyId',
            'Address',
            'MobilePhone',
          ]))
        }
      })
    },
  },
  components: {
    SprDialog,
    SprAddress,
  },
}
</script>

<style lang="less">
.work-place.address-box {
  display: block;
  width: auto !important;
  .el-col {
    width: auto;
    margin-right: 6px;
    &:nth-child(3), &:nth-child(4) {
      margin-right: 0;
    }
  }
  .province, .city, .county {
    width: 126px;
  }
  .address {
    width: 390px;
    margin-top: 6px;
  }
}
.inner-form {
  // margin-left: 67px;
  .el-form-item {
    margin: 0;
    .el-form-item__content {
      min-width: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// BranchCompanyDialog.vue?cb84a1da